import { getAuth, signOut } from 'firebase/auth';
import { cleanPolicies, getSummarize } from './summarize.service';
import { getUserByEmail } from './users.service';

const auth = getAuth();

export const login = async (email) => {
  try {
    const userInfo = await getUserByEmail(email);
    if (userInfo.email) {
      await getSummarize(userInfo.id);
      return {
        userObject: null,
        logged: true,
        user: userInfo
      }
    } else {
      return {
        userObject: null,
        logged: false,
        user: null
      }
    }
  } catch (err) {
    window.alert(JSON.stringify(err));
    return err;
  }
}

export const retrieveSession = async () => {
  return new Promise((res) => {
    setTimeout(() => {
      res(auth.currentUser);
    }, 3000);
  })
}

export const logout = async () => {
  try {
    await signOut(auth);
    cleanPolicies();
    return true;
  } catch (err) {
    return err;
  }
}